<template>
    <div id="urgency-dialog">

        <div class="modal"
             id="urgency-modal"
             tabindex="-1"
             role="dialog"
             aria-labelledby="urgencyModal"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form id="urgency-form" class="container-fluid text-left text-black font-weight-normal">

                            <header class="d-flex align-items-center mb-4">
                                <!--<img class="mb-2" src="/images/icons/urgencias.png" alt="">-->
                                <h2 class="mb-4">
                                    {{ __('site.Urgencies-24-hours') }}
                                </h2>
                            </header>

                            <fieldset class="row">
                                <div class="col-12 form-group">
                                    <input
                                            v-model="name"
                                            type="text"
                                            :placeholder="__('forms.Your-name')"
                                            class="form-control shadow border-0"
                                            required>
                                    <small
                                            v-if="this.errors.name"
                                            v-text="this.errors.name[0]"
                                            class="text-danger">
                                    </small>
                                </div>

                                <div class="col-12 form-group">
                                    <input
                                            v-model="surname"
                                            type="text"
                                            :placeholder="__('forms.Your-surname')"
                                            class="form-control shadow border-0"
                                            required>
                                    <small
                                            v-if="this.errors.surname"
                                            v-text="this.errors.surname[0]"
                                            class="text-danger">
                                    </small>
                                </div>

                                <div class="col-12 form-group">
                                    <input
                                            v-model="phoneNumber"
                                            type="tel"
                                            pattern="[0-9]{9}"
                                            :placeholder="__('forms.Your-phone-number')"
                                            class="form-control shadow border-0"
                                            min="9"
                                            required>
                                    <small
                                            v-if="this.errors.phone_number"
                                            v-text="this.errors.phone_number[0]"
                                            class="text-danger">
                                    </small>
                                </div>

                                <div class="col-12 form-group">
                        <textarea
                                v-model="message"
                                :placeholder="__('forms.Urgency-reason')"
                                class="form-control shadow border-0"
                                required>
                        </textarea>
                                    <small
                                            v-if="this.errors.message"
                                            v-text="this.errors.message[0]"
                                            class="text-danger">
                                    </small>
                                </div>


                            </fieldset>

                            <label class="form-check-label">
                                <input
                                        required="required"
                                        name="terms"
                                        type="checkbox"
                                        class="form-check-input"
                                        @click="updateTerms">
                                <a href="/legal" target="_blank" class="text-xs">
                                    {{ __('forms.Accept-terms-and-conditions') }}
                                </a>
                                <br/>
                                <small
                                        v-if="errors.terms"
                                        v-text="errors.terms[0]"
                                        class="text-danger">
                                </small>
                            </label>

                            <br>

                            <div class="text-center mb-4">
                                <small class="text-gray-dark">
                                    {{ __('site.Urgency-footnotes') }}
                                </small>
                            </div>

                            <fieldset class="col-12 text-center form-group">
                                <input
                                        type="submit"
                                        :value="__('site.Send')"
                                        class="btn btn-outline-secondary"
                                        @click.prevent="sendMessage"
                                        required>
                            </fieldset>

                        </form>
                    </div>
                </div>
            </div>
        </div>

        <modal-alert @confirm="successSendForm = false" v-if="successSendForm">
            <span slot="header">{{ __('site.Alert-confirm-header') }}</span>
            {{ __('site.Alert-confirm-message') }}
        </modal-alert>

    </div>
</template>

<script>
  export default {
    data: function () {
      return {
        name: '',
        surname: '',
        phoneNumber: '',
        message: '',
        terms: false,
        successSendForm: false,
        errors: [],
      }
    },

    mounted: function () {
      $('#app').on('click', '[data-form-urgency]', (event) => {
        event.preventDefault()
        $('#urgency-modal').modal('show')
        /* if ( ! this.openModalBox ) {
             this.openModalBox = true;
         }*/
      })
    },

    methods: {
      updateTerms: function () {
        this.terms = !this.terms
        console.log(this.terms)
      },
      sendMessage: function () {
        this.errors = []
        this.$http.post('/contact/urgency', {
          name: this.name,
          surname: this.surname,
          phone_number: this.phoneNumber,
          message: this.message,
          terms: this.terms
        }).then((response) => {
          // Correcto
          // ga('send', 'event', 'urgencia', 'enviar', null, 1)
          $('#urgency-modal').modal('hide')
          this.successSendForm = true
        }, (response) => {
          // Error
          // ga('send', 'event', 'urgencia', 'enviar', null, 0)
          this.errors = response.response.data
        })
      },
    },
  }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    #urgency-dialog {

        #urgency-form {
            max-width: 28rem;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/UrgencyDialog.vue